import HelpCentreModule from './HelpCentre.module';

export * from './HelpCentreModuleProps';
export default HelpCentreModule;
